import React from 'react'
import { Link } from 'react-router-dom';
function Thirdrow() {
  return (
    <>
    <div className='third-row-box'>
    <div data-aos="fade-up"
    data-aos-duration="1000" className='third-row-first-box'>
    <Link exact to='/about'>
    <div className='train-img'>
    
            <img src='aca.png' alt='Academic certificate'/>
            </div>
            <h4 className='card-h4'>ABOUT MY ACADEMICS</h4>
            <h3 className='card-h3'>Academics</h3>
            </Link>
          

    </div>
    <div data-aos="fade-up"
    data-aos-duration="1000" className='third-row-second-box'>
    
    <a href='/Rudra_karmakar_resume_frontend_ai.pdf' download='Rudra_karmakar_resume_frontend_ai.pdf'>
    <div className='train-img'>
            <img src='cv.png' alt='Curriculum Vitae document'/>
            </div>
            <h4 className='card-h4'>TO DOWNLOAD CV<span>  <svg
  width="20"
  height="20"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M11 5C11 4.44772 11.4477 4 12 4C12.5523 4 13 4.44772 13 5V12.1578L16.2428 8.91501L17.657 10.3292L12.0001 15.9861L6.34326 10.3292L7.75748 8.91501L11 12.1575V5Z"
    fill="currentColor"
  />
  <path
    d="M4 14H6V18H18V14H20V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V14Z"
    fill="currentColor"
  />
                </svg>
    </span>
            </h4>
            <h3 className='card-h3'>Curriculum Vitae</h3>
           
            </a>         
    </div>
    
    </div>
    </>
  );
}
export default Thirdrow;
